import { linkPage } from "@utils/router";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Select } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { LuBell, LuChevronRight, LuInbox } from "react-icons/lu";
import { AndroidDataEventMap } from "@declarations/event";
import { Inbox } from "@services/dtos/home.dto";
import { androidListInbox, androidReadInbox } from "@utils/android";
import { useInboxStore } from "@stores/inbox.store";
import { useThemeStore } from "@stores/theme.store";
import { PopupCustom } from "@components/general/popup";
import { Spiner } from "@components/loaders/spiner";
import moment from "moment";

export const InboxPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore(
    (state) => state
  );

  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [inboxs, setInboxs] = useState<Array<Inbox>>([]);

  const { updateUnreadInbox } = useInboxStore((state) => state);

  const onListInboxListener = useCallback(
    (ev: MessageEvent<AndroidDataEventMap["on-list-inbox"]>) => {
      setInboxs(ev.data);
      setLoading(false);
      updateUnreadInbox(ev.data.some((item) => !item.isRead));
    },
    [updateUnreadInbox]
  );

  useEffect(() => {
    setHeader({ buttonBack: true, filter: false, title: "Kotak Pesan", image: false });
    setAppBar({ title: "Kotak Pesan", show: true, leading: "back" });
    setBottomNavigation("hidden");
  }, [setHeader, setAppBar, setBottomNavigation]);

  useEffect(() => {
    setLoading(true);
    androidListInbox(limit);
  }, [limit]);

  useEffect(() => {
    window.addEventListener("on-list-inbox", onListInboxListener);
    return () => {
      window.removeEventListener("on-list-inbox", onListInboxListener);
    };
  }, [onListInboxListener]);

  const onOpenInbox = (inbox: Inbox) => {
    if (!inbox.isRead) {
      androidReadInbox(inbox.id.toString());
      const updated = inboxs.map((item) =>
        item.id === inbox.id ? { ...item, isRead: true } : item
      );
      setInboxs(updated);
      updateUnreadInbox(updated.some((item) => !item.isRead));
    }
    navigate(linkPage.INBOX_DETAIL_PAGE, { state: inbox });
  };

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
          <div className="tw-text-sm tw-text-text-secondary">
            Menampilkan{" "}
            <span className="tw-font-semibold tw-text-text-primary">
              {limit} pesan terakhir
            </span>
          </div>
          <FilterOutlined
            className="tw-p-2 tw-text-xl tw-bg-transparent card-body"
            onClick={() => setPopupFilter(true)}
          />
        </div>

        {loading ? (
          <div className="tw-text-center card-body tw-py-8">
            <Spiner />
          </div>
        ) : inboxs.length < 1 ? (
          <div className="tw-p-8 tw-text-center card-body">
            <LuInbox className="tw-mx-auto tw-mb-2 tw-text-5xl tw-text-text-secondary tw-opacity-40" />
            <div className="tw-text-sm tw-text-text-secondary">
              Data tidak ditemukan
            </div>
          </div>
        ) : (
          <div className="tw-space-y-3">
            {inboxs.map((item) => (
              <div
                key={item.id}
                onClick={() => onOpenInbox(item)}
                className="tw-p-3 tw-rounded-xl tw-cursor-pointer card-body"
              >
                <div className="tw-flex tw-items-start tw-gap-2">
                  <LuBell
                    className={`tw-shrink-0 tw-mt-0.5 ${
                      item.isRead ? "tw-text-text-secondary" : "tw-text-red-500"
                    }`}
                    size={16}
                  />
                  <div className="tw-min-w-0 tw-flex-1">
                    <div className="tw-flex tw-items-center tw-justify-between tw-gap-2">
                      <div className="tw-font-semibold tw-text-sm tw-text-text-primary tw-truncate">
                        {item.title}
                      </div>
                      <LuChevronRight
                        className="tw-text-background-400 tw-shrink-0"
                        size={14}
                      />
                    </div>
                    <div className="tw-text-[10px] tw-text-text-tertiary tw-mt-0.5">
                      {moment(item.createdAt || Date.now()).format(
                        "dddd, DD MMMM YYYY | HH:mm"
                      )}
                    </div>
                    <div className="tw-text-xs tw-text-text-secondary tw-mt-1 tw-line-clamp-1">
                      {item.message}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <Select
          className="tw-text-base"
          placeholder="Pilih Jumlah Ditampilkan"
          defaultValue={limit}
          style={{ width: "100%" }}
          allowClear
          onChange={(e) => setLimit(e)}
          options={[
            { value: "10", label: "10 pesan terakhir" },
            { value: "25", label: "25 pesan terakhir" },
            { value: "50", label: "50 pesan terakhir" },
          ]}
        />
        <Button
          onClick={() => setPopupFilter(false)}
          className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-sm tw-rounded-xl tw-border-0 tw-text-white focus:tw-shadow-none"
          style={{ background: "#ef4444" }}
        >
          Tutup
        </Button>
      </PopupCustom>
    </>
  );
};
